export enum UserTypeEnum {
  RESELLER = "Reseller",
  MERCHANT = "Merchant",
  GLOBAL = "Global",
  CUSTOMER = "Customer",
  PARTNER = "Partner",
  ALLY = "Ally"
}